import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import ConcursosLogged from '../../../../components/auth/rh/concursos'

function ConcursosLoggedScreen() {
        return (
            <Fragment>
                <Head titulo="Módulo de Concursos Públicos - Recursos Humanos" />
                <HeaderLogged />
                <Container>
                   <ConcursosLogged />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default ConcursosLoggedScreen;